// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
    --primary: #e84200;
    --red: #fa2d00;
    --grey1: #d7d7d7;
    --grey2: #d9d9d9;
    --grey4: #a1a1a1;
    --grey5: #727272;
    --darkgrey1: #222222;
    --darkgrey2: #1c1b1f;
    --darkgrey3: #000000;
    --white: #ffffff;
    --lightgrey2: #f1f1f1;
}

.product-detail-page {
    font-family: 'Noto Sans KR', sans-serif;
    background-color: var(--white, #ffffff);
}

.detail-breadcrumb {
    padding: 21px 40px;
    background: var(--lightgrey2, #f1f1f1);
    border-bottom: none;
}

.breadcrumb-content {
    display: flex;
    flex-direction: row;
    gap: 12px;
    align-items: center;
    justify-content: flex-start;
}

.breadcrumb-content a,
.breadcrumb-content span {
    color: var(--grey5, #727272);
    text-align: left;
    font-family: "Inter-Regular", sans-serif;
    font-size: 16px;
    font-weight: 400;
    text-decoration: none;
}

.breadcrumb-content .current {
    color: var(--darkgrey3, #000000);
    font-family: "Inter-Bold", sans-serif;
    font-weight: 700;
}

.detail-main-content {
    max-width: 1320px;
    margin: 0 auto;
    padding: 40px 0;
}

.detail-title-section {
    padding: 0 50px;
    padding-bottom: 38px;
    border-bottom: 1px solid var(--darkgrey1, #222222);
    margin-bottom: 0;
}

.detail-title-section h1 {
    color: var(--darkgrey3, #000000);
    text-align: left;
    font-family: "Inter-SemiBold", sans-serif;
    font-size: 28px;
    font-weight: 600;
    margin: 0;
    flex: 1 1;
    height: 41px;
}

.detail-content-section {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    width: 1320px;
    max-width: 100%;
    margin: 0 auto;
    margin-top: 0;
    flex-wrap: wrap;
}

.product-gallery {
    display: flex;
    flex-direction: row;
    gap: 14px;
    align-items: flex-start;
    padding: 100px 0 100px 70px;
    flex-shrink: 0;
}

.gallery-thumbnails {
    display: flex;
    flex-direction: column;
    gap: 8px;
    align-items: flex-start;
    flex-shrink: 0;
    width: 176px;
}

.thumbnail-wrapper {
    border-radius: 3px;
    border: 1px solid var(--grey4, #a1a1a1);
    width: 176px;
    height: 176px;
    position: relative;
    overflow: hidden;
}

.thumbnail {
    width: 100%;
    height: 100%;
    object-fit: cover;
    cursor: pointer;
}

.main-image-container {
    flex-shrink: 0;
    width: 480px;
    height: 480px;
    position: relative;
    overflow: visible;
    border: none;
    background: transparent;
    border-radius: 0;
    min-height: auto;
}

.main-image {
    width: 100%;
    height: auto;
    object-fit: contain;
    display: block;
    max-width: 100%;
    max-height: 100%;
}

.product-details {
    flex-shrink: 0;
    width: 540px;
    position: relative;
}

.detail-options {
    background: transparent;
    padding: 0;
    border-radius: 0;
    border: none;
    border-bottom: 1px solid var(--darkgrey1, #222222);
    padding: 32px 16px;
}

.option-row {
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 4px;
    flex-wrap: wrap;
}

.option-row:last-child {
    margin-bottom: 0;
}

.option-label {
    color: var(--darkgrey3, #000000);
    text-align: left;
    font-family: "Inter-Medium", sans-serif;
    font-size: 18px;
    font-weight: 500;
    width: 175px;
    flex-shrink: 0;
}

.option-value {
    color: var(--grey5, #727272);
    text-align: left;
    font-family: "Inter-Medium", sans-serif;
    font-size: 18px;
    font-weight: 500;
}

.option-select {
    padding: 14px 16px;
    border: 1px solid var(--grey1, #d7d7d7);
    border-radius: 5px;
    font-size: 18px;
    font-family: "Inter-Medium", sans-serif;
    font-weight: 500;
    background: var(--white, #ffffff);
    color: var(--darkgrey3, #000000);
    width: 290px;
    height: 53px;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    box-sizing: border-box;
}

.quantity-selector {
    display: flex;
    flex-direction: row;
    gap: 0;
    align-items: center;
    justify-content: space-between;
    flex-shrink: 0;
    position: relative;
    border: none;
    border-radius: 5px;
    width: 290px;
    height: 53px;
    box-sizing: border-box;
}

.quantity-selector button {
    width: 53px;
    height: 53px;
    border: 1px solid var(--grey2, #d9d9d9);
    background: var(--white, #ffffff);
    color: var(--darkgrey3, #000000);
    cursor: pointer;
    border-radius: 0;
    font-size: 20px;
    font-weight: 500;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
    flex-shrink: 0;
    box-sizing: border-box;
}

.quantity-selector button:first-child {
    border-top-left-radius: 5px;
    border-bottom-left-radius: 5px;
    border-right: none;
}

.quantity-selector button:last-child {
    border-top-right-radius: 5px;
    border-bottom-right-radius: 5px;
    border-left: none;
}

.quantity-selector-centered button {
    color: var(--darkgrey3, #000000);
    font-weight: 600;
}

.quantity-icon {
    width: 33px;
    height: 33px;
    object-fit: contain;
}

.quantity-selector button:hover {
    background: var(--lightgrey2, #f1f1f1);
    opacity: 1;
}

.quantity-selector span {
    border-top: 1px solid var(--grey2, #d9d9d9);
    border-bottom: 1px solid var(--grey2, #d9d9d9);
    border-left: 1px solid var(--grey2, #d9d9d9);
    border-right: 1px solid var(--grey2, #d9d9d9);
    padding: 5px 4px;
    flex: 1 1;
    min-width: 74.41px;
    height: 53px;
    text-align: center;
    font-family: "Inter-Regular", sans-serif;
    font-size: 18px;
    font-weight: 400;
    color: var(--darkgrey3, #000000);
    display: flex;
    align-items: center;
    justify-content: center;
    background: var(--white, #ffffff);
    box-sizing: border-box;
}

.selected-options {
    margin: 20px 0;
    padding: 20px;
    background: #f8f9fa;
    border-radius: 8px;
    border: 1px solid #e0e0e0;
}

.selected-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px;
    background: white;
    border-radius: 4px;
    margin-bottom: 10px;
    border: 1px solid #e0e0e0;
}

.selected-item:last-child {
    margin-bottom: 0;
}

.item-info p {
    margin: 0;
    font-size: 14px;
    color: #555;
}

.item-info p:first-child {
    font-weight: 500;
}

.item-info p:last-child {
    color: #888;
    font-size: 14px;
}

.item-controls {
    display: flex;
    align-items: center;
    gap: 10px;
}

.remove-item {
    background: var(--primary, #e84200);
    color: white;
    border: none;
    width: 24px;
    height: 24px;
    border-radius: 4px;
    cursor: pointer;
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.remove-item:hover {
    background: #d73502;
}

.detail-options-divider {
    padding: 40px 16px;
    height: 172px;
}

.product-actions-container {
    padding: 0 16px;
    width: 100%;
    max-width: 540px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
}

.add-to-cart-btn {
    background: var(--primary, #e84200);
    border-radius: 5px;
    padding: 15px;
    display: flex;
    flex-direction: row;
    gap: 10px;
    align-items: center;
    justify-content: center;
    width: 430px;
    height: 53px;
    border: none;
    cursor: pointer;
    color: var(--white, #ffffff);
    text-align: center;
    font-family: "Inter-Bold", sans-serif;
    font-size: 18px;
    font-weight: 700;
    transition: background-color 0.2s ease;
    margin: 0 auto;
}

.add-to-cart-btn:hover:not(:disabled) {
    background: #d73502;
}

.add-to-cart-btn:disabled {
    background: var(--grey4, #a1a1a1);
    cursor: not-allowed;
}

.add-options-btn {
    background: var(--primary, #e84200);
    color: var(--white, #ffffff);
    border: none;
    padding: 12px 24px;
    border-radius: 6px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: background-color 0.2s ease;
    margin-left: 0;
}

.add-options-btn:hover:not(:disabled):not(.disabled) {
    background: #d73502;
}

.add-options-btn:disabled,
.add-options-btn.disabled {
    background: var(--grey4, #a1a1a1);
    cursor: pointer;
}

.info-box {
    background: transparent;
    border: none;
    border-radius: 0;
    padding: 10px 0;
    margin: 20px 0;
    width: 100%;
    max-width: 430px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    text-align: left;
}

.info-box p {
    margin: 0;
    color: var(--darkgrey3, #000000);
    font-family: "Inter-Regular", sans-serif;
    font-size: 18px;
    line-height: 30px;
    font-weight: 400;
    text-align: left;
}

.info-box ul {
    margin: 0 auto;
    padding-left: 1em;
    list-style-type: disc;
    color: var(--darkgrey3, #000000);
    font-family: "Inter-Regular", sans-serif;
    font-size: 18px;
    line-height: 30px;
    font-weight: 400;
    width: fit-content;
}

.info-box span {
    color: var(--darkgrey3, #000000);
    font-family: "Inter-Regular", sans-serif;
    font-size: 18px;
    line-height: 30px;
    font-weight: 400;
    text-align: center;
    display: block;
    width: 100%;
}

.document-buttons {
    display: flex;
    flex-direction: column;
    gap: 12px;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    width: 430px;
    margin-top: 49px;
    margin-left: auto;
    margin-right: auto;
}

.doc-btn {
    align-self: stretch;
    flex-shrink: 0;
    height: 53px;
    position: relative;
    border-radius: 5px;
    cursor: pointer;
    font-size: 18px;
    transition: all 0.2s ease;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 42px;
}

.pdf-btn {
    background: var(--white, #ffffff);
    border: 1px solid var(--darkgrey3, #000000);
    color: var(--darkgrey3, #000000);
}

.pdf-btn:hover {
    border-color: var(--primary, #e84200);
    color: var(--primary, #e84200);
}

.cad-btn {
    background: var(--darkgrey3, #000000);
    border: 1px solid var(--darkgrey3, #000000);
    color: var(--white, #ffffff);
}

.cad-btn:hover {
    background: var(--primary, #e84200);
    border-color: var(--primary, #e84200);
}

.doc-btn span {
    font-family: "Inter-Bold", sans-serif;
    font-size: 18px;
    font-weight: 700;
}

.doc-btn span:first-child {
    text-align: left;
}

.doc-btn span:last-child {
    text-align: right;
}

.product-detail-image-section {
    width: 100%;
    margin: 40px 0;
    text-align: center;
}

.detail-main-image {
    width: 100%;
    max-width: 1240px;
    height: auto;
    object-fit: contain;
}

.product-extra-details {
    border-radius: 15px;
    border: 1px solid var(--grey2, #d9d9d9);
    padding: 180px 100px 90px 100px;
    display: flex;
    flex-direction: column;
    gap: 240px;
    align-items: flex-start;
    justify-content: flex-start;
    width: 1240px;
    max-width: 100%;
    margin: 40px auto;
    background: var(--white, #ffffff);
}

.detail-image-full {
    margin-bottom: 60px;
    text-align: center;
}

.detail-image-full img {
    max-width: 100%;
    height: auto;
}

.purchase-info-section {
    display: flex;
    flex-direction: column;
    gap: 40px;
    align-items: flex-start;
    justify-content: flex-start;
    align-self: stretch;
    flex-shrink: 0;
    position: relative;
}

.purchase-info-section h3 {
    color: var(--darkgrey3, #000000);
    text-align: left;
    font-family: "Inter-SemiBold", sans-serif;
    font-size: 18px;
    font-weight: 600;
    position: relative;
    align-self: stretch;
    margin: 0;
}

.purchase-steps {
    padding: 0 30px;
    display: flex;
    flex-direction: column;
    gap: 19px;
    align-items: flex-start;
    justify-content: flex-start;
    align-self: stretch;
    flex-shrink: 0;
    position: relative;
}

.purchase-desc {
    color: var(--grey5, #727272);
    text-align: left;
    font-family: "Inter-Medium", sans-serif;
    font-size: 16px;
    line-height: 28px;
    font-weight: 500;
    position: relative;
    align-self: stretch;
    margin: 0;
}

.contact-methods {
    display: flex;
    flex-direction: column;
    gap: 4px;
    align-items: flex-start;
    justify-content: flex-start;
    flex-shrink: 0;
    width: 281px;
    position: relative;
}

.contact-item {
    display: flex;
    flex-direction: row;
    gap: 11px;
    align-items: center;
    justify-content: flex-start;
    align-self: stretch;
    flex-shrink: 0;
    position: relative;
}

.contact-icon {
    border-radius: 0px;
    flex-shrink: 0;
    width: 19px;
    height: 19px;
    position: relative;
    overflow: visible;
}

.contact-info {
    display: flex;
    flex-direction: row;
    gap: 4px;
    align-items: center;
    justify-content: flex-start;
    flex-shrink: 0;
    position: relative;
}

.contact-label {
    color: var(--darkgrey3, #000000);
    text-align: left;
    font-family: "Inter-SemiBold", sans-serif;
    font-size: 18px;
    line-height: 28px;
    font-weight: 600;
    position: relative;
}

.contact-value {
    color: var(--primary, #e84200);
    text-align: left;
    font-family: "Inter-SemiBold", sans-serif;
    font-size: 18px;
    line-height: 28px;
    font-weight: 600;
    position: relative;
    text-decoration: none;
}

.purchase-steps-indicator {
    padding: 10px 80px;
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items: flex-start;
    justify-content: flex-start;
    flex-shrink: 0;
    position: relative;
}

.step-indicator {
    flex-shrink: 0;
    width: 466px;
    height: 25px;
    position: relative;
}

.step-indicator-bg {
    background: var(--primary, #e84200);
    width: 94.64%;
    height: 12%;
    position: absolute;
    right: 2.58%;
    left: 2.79%;
    bottom: 44%;
    top: 44%;
    z-index: 1;
}

.step-indicator-fill {
    background: var(--primary, #e84200);
    width: 47.42%;
    height: 12%;
    position: absolute;
    right: 49.79%;
    left: 2.79%;
    bottom: 44%;
    top: 44%;
    z-index: 2;
}

.step-item {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: center;
    justify-content: flex-start;
    width: 5.36%;
    height: 100%;
    position: absolute;
    z-index: 3;
}

.step-item:first-child {
    right: 94.64%;
    left: 0%;
    bottom: 0%;
    top: 0%;
}

.step-item:nth-child(3) {
    right: 47.21%;
    left: 47.42%;
    bottom: 0%;
    top: 0%;
}

.step-item:last-child {
    right: 0%;
    left: 94.64%;
    bottom: 0%;
    top: 0%;
}

.step-circle {
    background: var(--primary, #e84200);
    border-radius: 50%;
    flex-shrink: 0;
    width: 25px;
    height: 25px;
    position: relative;
}

.step-item span {
    color: var(--darkgrey3, #000000);
    text-align: center;
    font-family: "Inter-SemiBold", sans-serif;
    font-size: 18px;
    font-weight: 600;
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 45px;
    white-space: nowrap;
}

.purchase-info-section h3:last-of-type {
    margin-top: 50px;
}

.specs-content {
    padding: 0 30px;
    display: flex;
    flex-direction: row;
    gap: 8px;
    align-items: center;
    justify-content: flex-start;
    align-self: stretch;
    flex-shrink: 0;
    position: relative;
}

.specs-labels {
    color: var(--grey5, #727272);
    text-align: left;
    font-family: "Inter-Medium", sans-serif;
    font-size: 16px;
    line-height: 30px;
    font-weight: 500;
    position: relative;
    width: 143px;
}

.specs-values {
    color: var(--grey5, #727272);
    text-align: left;
    font-family: "Inter-Medium", sans-serif;
    font-size: 16px;
    line-height: 30px;
    font-weight: 500;
    position: relative;
    flex: 1 1;
}

.shipping-exchange-section {
    display: flex;
    flex-direction: column;
    gap: 60px;
    align-items: flex-start;
    justify-content: flex-start;
    width: 1240px;
    max-width: 100%;
    padding: 0 100px;
    margin: 0 auto;
}

.shipping-info-section,
.exchange-info-section {
    display: flex;
    flex-direction: column;
    gap: 20px;
    align-items: flex-start;
    justify-content: flex-start;
    align-self: stretch;
    flex-shrink: 0;
    position: relative;
}

.shipping-info-section h3,
.exchange-info-section h3 {
    color: var(--darkgrey3, #000000);
    text-align: left;
    font-family: "Inter-SemiBold", sans-serif;
    font-size: 18px;
    font-weight: 600;
    position: relative;
    align-self: stretch;
    margin: 0;
}

.info-content {
    padding: 0 30px;
    color: var(--grey5, #727272);
    text-align: left;
    font-family: "Inter-Medium", sans-serif;
    font-size: 16px;
    font-weight: 500;
    position: relative;
    flex: 1 1;
    line-height: 1.8;
}

/* Tablet and smaller devices */
@media (max-width: 1024px) {
    .detail-main-content {
        padding: 20px;
    }

    .detail-content-section {
        flex-direction: column;
    }

    .product-gallery, .product-details {
        width: 100%;
    }
}

/* Mobile devices */
@media (max-width: 768px) {
    .detail-breadcrumb {
        padding: 12px 15px;
    }
    
    .breadcrumb-content {
        font-size: 11px;
        flex-wrap: wrap;
        gap: 6px;
    }
    
    .breadcrumb-content a,
    .breadcrumb-content span {
        font-size: 11px;
    }
    
    .detail-main-content {
        padding: 15px;
        width: 100%;
        max-width: 100%;
    }

    .detail-title-section {
        padding: 0 15px;
        padding-bottom: 15px;
        margin-bottom: 0;
    }

    .detail-title-section h1 {
        font-size: 18px;
        height: auto;
        line-height: 1.4;
    }

    .detail-content-section {
        flex-direction: column;
        width: 100%;
        padding: 0;
        margin-top: 0;
    }

    .product-gallery {
        flex-direction: column;
        padding: 15px 0;
        width: 100%;
        gap: 10px;
    }

    .gallery-thumbnails {
        flex-direction: row;
        overflow-x: auto;
        width: 100%;
        gap: 8px;
        padding: 0 15px 10px 15px;
        -webkit-overflow-scrolling: touch;
    }
    
    .thumbnail-wrapper {
        flex-shrink: 0;
        width: 80px;
        height: 80px;
    }
    
    .thumbnail {
        width: 80px;
        height: 80px;
    }

    .main-image-container {
        width: 100%;
        height: auto;
        order: -1;
        padding: 0 15px;
    }
    
    .main-image {
        width: 100%;
        height: auto;
        max-height: 400px;
        object-fit: contain;
    }

    .product-details {
        width: 100%;
        padding: 20px 15px;
    }
    
    .detail-options {
        padding: 20px 15px;
    }

    .option-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
        width: 100%;
        margin-bottom: 15px;
    }
    
    .option-label {
        min-width: auto;
        margin-right: 0;
        width: 100%;
        font-size: 16px;
    }
    
    .option-value,
    .option-select {
        width: 100%;
        font-size: 16px;
    }
    
    .quantity-selector {
        width: 100%;
        height: 40px;
        justify-content: space-between;
    }
    
    .quantity-selector button,
    .quantity-icon {
        width: 40px;
        height: 40px;
    }
    
    .quantity-selector span {
        font-size: 16px;
        min-width: 60px;
        height: 40px;
    }
    
    .option-select {
        width: 100%;
        height: 40px;
    }
    
    .selected-options {
        margin: 15px 0;
        padding: 15px;
    }
    
    .selected-item {
        flex-direction: column;
        align-items: flex-start;
        gap: 10px;
        padding: 12px;
    }
    
    .item-controls {
        width: 100%;
        justify-content: flex-end;
    }
    
    .add-to-cart-btn {
        width: 100%;
        max-width: 100%;
        height: 48px;
        font-size: 16px;
        padding: 12px;
    }
    
    .add-options-btn {
        width: 100%;
        padding: 12px;
        font-size: 14px;
    }
    
    .detail-options-divider {
        padding: 30px 15px;
        height: auto;
    }
    
    .info-box {
        padding: 15px;
        margin: 15px 0;
    }
    
    .info-box p,
    .info-box ul,
    .info-box span {
        font-size: 14px;
        line-height: 1.6;
        text-align: left;
    }
    
    .document-buttons {
        flex-direction: column;
        width: 100%;
        margin-top: 30px;
        gap: 10px;
    }
    
    .doc-btn {
        width: 100%;
        height: 48px;
        padding: 0 20px;
        font-size: 16px;
    }
    
    .doc-btn span {
        font-size: 16px;
    }
    
    .product-extra-details {
        width: 100%;
        padding: 30px 15px;
        margin: 20px auto;
        gap: 40px;
        border-radius: 8px;
    }
    
    .detail-image-full {
        margin-bottom: 30px;
    }
    
    .detail-image-full img {
        width: 100%;
        height: auto;
    }
    
    .purchase-info-section {
        padding: 20px 15px;
        width: 100%;
    }
    
    .purchase-steps {
        flex-direction: column;
        gap: 15px;
        margin: 20px 0;
        padding: 0;
    }
    
    .purchase-steps-indicator {
        padding: 10px 0;
        width: 100%;
    }
    
    .step-indicator {
        width: 100%;
        max-width: 100%;
        height: 20px;
    }
    
    .step-item span {
        font-size: 12px;
        top: 30px;
    }
    
    .purchase-desc {
        font-size: 14px;
        line-height: 1.6;
        margin: 15px 0;
        padding: 0;
    }
    
    .contact-methods {
        flex-direction: column;
        gap: 15px;
        margin: 20px 0;
        width: 100%;
        padding: 0;
    }
    
    .contact-item {
        width: 100%;
        padding: 10px 0;
    }
    
    .contact-label,
    .contact-value {
        font-size: 14px;
        line-height: 1.6;
    }
    
    .contact-icon {
        width: 16px;
        height: 16px;
    }
    
    .specs-content {
        flex-direction: column;
        gap: 10px;
        padding: 0;
        margin: 15px 0;
    }
    
    .specs-labels,
    .specs-values {
        font-size: 14px;
        line-height: 1.6;
        width: 100%;
    }
    
    .specs-table {
        width: 100%;
        font-size: 12px;
        margin: 15px 0;
        display: block;
        overflow-x: auto;
    }
    
    .specs-table th,
    .specs-table td {
        padding: 10px 8px;
        font-size: 12px;
        white-space: nowrap;
    }
    
    .shipping-exchange-section {
        width: 100%;
        padding: 0 15px;
        margin: 0 auto;
        gap: 40px;
    }
    
    .shipping-info-section,
    .exchange-info-section {
        padding: 20px 0;
        width: 100%;
        gap: 15px;
    }
    
    .shipping-info-section h3,
    .exchange-info-section h3 {
        font-size: 18px;
        margin-bottom: 10px;
    }
    
    .info-content {
        padding: 0;
        font-size: 14px;
        line-height: 1.6;
    }
    
    .shipping-info-section p,
    .exchange-info-section p {
        font-size: 14px;
        line-height: 1.6;
        margin: 10px 0;
    }
    
    .product-detail-image-section {
        margin: 20px 0;
        padding: 0 15px;
    }
    
    .detail-main-image {
        width: 100%;
        max-width: 100%;
    }
}

/* Full width 이미지 스타일 */
.detail-image-full-width {
    width: 100%;
    margin: 20px 0;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    overflow: hidden;
    background: #f8f9fa;
}

.detail-image-full-width img {
    width: 100%;
    height: auto;
    object-fit: contain;
    display: block;
}

.detail-image-full-width .image-placeholder {
    width: 100%;
    height: 300px;
    border-radius: 8px;
    background-color: #f8f9fa;
    display: flex;
    align-items: center;
    justify-content: center;
}

@media (max-width: 768px) {
    .detail-image-full-width {
        padding: 0 20px;
        margin: 15px auto;
    }
    
    .detail-image-full-width .image-placeholder {
        height: 200px;
    }
} 

/* 반응형 디자인 */
@media (max-width: 768px) {
    .detail-content-section {
        flex-direction: column;
        gap: 20px;
    }
    
    .product-gallery {
        margin-right: 0;
        max-width: 100%;
    }
    
    .option-row {
        flex-direction: column;
        align-items: flex-start;
        gap: 8px;
    }
    
    .option-label {
        min-width: auto;
        margin-right: 0;
    }
    
    .document-buttons {
        flex-direction: column;
    }
    
    .detail-breadcrumb {
        padding: 15px 20px;
    }
    
    .breadcrumb-content {
        flex-wrap: wrap;
        gap: 8px;
    }
    
    .detail-title-section {
        padding: 20px;
    }
    
    .detail-title-section h1 {
        font-size: 24px;
    }
    
    .detail-main-content {
        padding: 0 20px 40px;
    }
}

@media (max-width: 480px) {
    .detail-breadcrumb {
        padding: 10px 15px;
    }
    
    .breadcrumb-content {
        font-size: 14px;
    }
    
    .detail-title-section {
        padding: 15px;
    }
    
    .detail-title-section h1 {
        font-size: 20px;
    }
    
    .detail-main-content {
        padding: 0 15px 30px;
    }
    
    .option-row {
        margin-bottom: 15px;
    }
    
    .option-label {
        font-size: 14px;
    }
    
    .option-select,
    .quantity-selector {
        font-size: 14px;
    }
    
    .add-options-btn {
        padding: 10px 20px;
        font-size: 14px;
    }
    
    .info-box {
        padding: 12px;
        font-size: 13px;
    }
    
    .doc-btn {
        padding: 10px 14px;
        font-size: 13px;
    }
} `, "",{"version":3,"sources":["webpack://./src/pages/css/ProductDetailPage.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,oBAAoB;IACpB,oBAAoB;IACpB,oBAAoB;IACpB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,uCAAuC;IACvC,uCAAuC;AAC3C;;AAEA;IACI,kBAAkB;IAClB,sCAAsC;IACtC,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,2BAA2B;AAC/B;;AAEA;;IAEI,4BAA4B;IAC5B,gBAAgB;IAChB,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,qCAAqC;IACrC,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,oBAAoB;IACpB,kDAAkD;IAClD,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,SAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;IAC9B,aAAa;IACb,eAAe;IACf,cAAc;IACd,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,uBAAuB;IACvB,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;IACvB,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,uCAAuC;IACvC,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,YAAY;IACZ,uBAAuB;IACvB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,uBAAuB;IACvB,UAAU;IACV,gBAAgB;IAChB,YAAY;IACZ,kDAAkD;IAClD,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,2BAA2B;IAC3B,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,uCAAuC;IACvC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,uCAAuC;IACvC,kBAAkB;IAClB,eAAe;IACf,uCAAuC;IACvC,gBAAgB;IAChB,iCAAiC;IACjC,gCAAgC;IAChC,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,MAAM;IACN,mBAAmB;IACnB,8BAA8B;IAC9B,cAAc;IACd,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,uCAAuC;IACvC,iCAAiC;IACjC,gCAAgC;IAChC,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,UAAU;IACV,cAAc;IACd,sBAAsB;AAC1B;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,+BAA+B;IAC/B,iBAAiB;AACrB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,sCAAsC;IACtC,UAAU;AACd;;AAEA;IACI,2CAA2C;IAC3C,8CAA8C;IAC9C,4CAA4C;IAC5C,6CAA6C;IAC7C,gBAAgB;IAChB,SAAO;IACP,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,wCAAwC;IACxC,eAAe;IACf,gBAAgB;IAChB,gCAAgC;IAChC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,iCAAiC;IACjC,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,mCAAmC;IACnC,YAAY;IACZ,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,aAAa;AACjB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,YAAY;IACZ,YAAY;IACZ,eAAe;IACf,4BAA4B;IAC5B,kBAAkB;IAClB,qCAAqC;IACrC,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,mBAAmB;AACvB;;AAEA;IACI,mCAAmC;IACnC,4BAA4B;IAC5B,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,gBAAgB;IAChB,sCAAsC;IACtC,cAAc;AAClB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;IAEI,iCAAiC;IACjC,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,gBAAgB;IAChB,eAAe;IACf,cAAc;IACd,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,SAAS;IACT,gCAAgC;IAChC,wCAAwC;IACxC,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,iBAAiB;IACjB,qBAAqB;IACrB,gCAAgC;IAChC,wCAAwC;IACxC,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,wCAAwC;IACxC,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,cAAc;IACd,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;IACd,YAAY;IACZ,gBAAgB;IAChB,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,YAAY;IACZ,kBAAkB;IAClB,kBAAkB;IAClB,eAAe;IACf,eAAe;IACf,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,iCAAiC;IACjC,2CAA2C;IAC3C,gCAAgC;AACpC;;AAEA;IACI,qCAAqC;IACrC,8BAA8B;AAClC;;AAEA;IACI,qCAAqC;IACrC,2CAA2C;IAC3C,4BAA4B;AAChC;;AAEA;IACI,mCAAmC;IACnC,qCAAqC;AACzC;;AAEA;IACI,qCAAqC;IACrC,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,uCAAuC;IACvC,+BAA+B;IAC/B,aAAa;IACb,sBAAsB;IACtB,UAAU;IACV,uBAAuB;IACvB,2BAA2B;IAC3B,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,iCAAiC;AACrC;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,2BAA2B;IAC3B,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,2BAA2B;IAC3B,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,uCAAuC;IACvC,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;IACvB,2BAA2B;IAC3B,cAAc;IACd,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,2BAA2B;IAC3B,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,yCAAyC;IACzC,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,yCAAyC;IACzC,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,2BAA2B;IAC3B,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,mCAAmC;IACnC,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,mCAAmC;IACnC,aAAa;IACb,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,WAAW;IACX,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,2BAA2B;IAC3B,YAAY;IACZ,YAAY;IACZ,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,aAAa;IACb,QAAQ;IACR,UAAU;IACV,OAAO;AACX;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,UAAU;IACV,OAAO;AACX;;AAEA;IACI,SAAS;IACT,YAAY;IACZ,UAAU;IACV,OAAO;AACX;;AAEA;IACI,mCAAmC;IACnC,kBAAkB;IAClB,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,gCAAgC;IAChC,kBAAkB;IAClB,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,SAAS;IACT,2BAA2B;IAC3B,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,2BAA2B;IAC3B,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,uCAAuC;IACvC,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;AAChB;;AAEA;IACI,4BAA4B;IAC5B,gBAAgB;IAChB,uCAAuC;IACvC,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,kBAAkB;IAClB,SAAO;AACX;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,2BAA2B;IAC3B,aAAa;IACb,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;;IAEI,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,uBAAuB;IACvB,2BAA2B;IAC3B,mBAAmB;IACnB,cAAc;IACd,kBAAkB;AACtB;;AAEA;;IAEI,gCAAgC;IAChC,gBAAgB;IAChB,yCAAyC;IACzC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,4BAA4B;IAC5B,gBAAgB;IAChB,uCAAuC;IACvC,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,SAAO;IACP,gBAAgB;AACpB;;AAEA,+BAA+B;AAC/B;IACI;QACI,aAAa;IACjB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,WAAW;IACf;AACJ;;AAEA,mBAAmB;AACnB;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,QAAQ;IACZ;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,eAAe;QACf,oBAAoB;QACpB,gBAAgB;IACpB;;IAEA;QACI,eAAe;QACf,YAAY;QACZ,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,WAAW;QACX,UAAU;QACV,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,eAAe;QACf,WAAW;QACX,SAAS;IACb;;IAEA;QACI,mBAAmB;QACnB,gBAAgB;QAChB,WAAW;QACX,QAAQ;QACR,yBAAyB;QACzB,iCAAiC;IACrC;;IAEA;QACI,cAAc;QACd,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,SAAS;QACT,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,iBAAiB;QACjB,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,kBAAkB;IACtB;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;QACT,WAAW;QACX,mBAAmB;IACvB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,WAAW;QACX,eAAe;IACnB;;IAEA;;QAEI,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,8BAA8B;IAClC;;IAEA;;QAEI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,cAAc;QACd,aAAa;IACjB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,SAAS;QACT,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,yBAAyB;IAC7B;;IAEA;QACI,WAAW;QACX,eAAe;QACf,YAAY;QACZ,eAAe;QACf,aAAa;IACjB;;IAEA;QACI,WAAW;QACX,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,YAAY;IAChB;;IAEA;QACI,aAAa;QACb,cAAc;IAClB;;IAEA;;;QAGI,eAAe;QACf,gBAAgB;QAChB,gBAAgB;IACpB;;IAEA;QACI,sBAAsB;QACtB,WAAW;QACX,gBAAgB;QAChB,SAAS;IACb;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,kBAAkB;QAClB,iBAAiB;QACjB,SAAS;QACT,kBAAkB;IACtB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,kBAAkB;QAClB,WAAW;IACf;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,cAAc;QACd,UAAU;IACd;;IAEA;QACI,eAAe;QACf,WAAW;IACf;;IAEA;QACI,WAAW;QACX,eAAe;QACf,YAAY;IAChB;;IAEA;QACI,eAAe;QACf,SAAS;IACb;;IAEA;QACI,eAAe;QACf,gBAAgB;QAChB,cAAc;QACd,UAAU;IACd;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,cAAc;QACd,WAAW;QACX,UAAU;IACd;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;;IAEA;;QAEI,eAAe;QACf,gBAAgB;IACpB;;IAEA;QACI,WAAW;QACX,YAAY;IAChB;;IAEA;QACI,sBAAsB;QACtB,SAAS;QACT,UAAU;QACV,cAAc;IAClB;;IAEA;;QAEI,eAAe;QACf,gBAAgB;QAChB,WAAW;IACf;;IAEA;QACI,WAAW;QACX,eAAe;QACf,cAAc;QACd,cAAc;QACd,gBAAgB;IACpB;;IAEA;;QAEI,iBAAiB;QACjB,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,cAAc;QACd,SAAS;IACb;;IAEA;;QAEI,eAAe;QACf,WAAW;QACX,SAAS;IACb;;IAEA;;QAEI,eAAe;QACf,mBAAmB;IACvB;;IAEA;QACI,UAAU;QACV,eAAe;QACf,gBAAgB;IACpB;;IAEA;;QAEI,eAAe;QACf,gBAAgB;QAChB,cAAc;IAClB;;IAEA;QACI,cAAc;QACd,eAAe;IACnB;;IAEA;QACI,WAAW;QACX,eAAe;IACnB;AACJ;;AAEA,uBAAuB;AACvB;IACI,WAAW;IACX,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI;QACI,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,aAAa;IACjB;AACJ;;AAEA,YAAY;AACZ;IACI;QACI,sBAAsB;QACtB,SAAS;IACb;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,sBAAsB;QACtB,uBAAuB;QACvB,QAAQ;IACZ;;IAEA;QACI,eAAe;QACf,eAAe;IACnB;;IAEA;QACI,sBAAsB;IAC1B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;QACf,QAAQ;IACZ;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,oBAAoB;IACxB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;;IAEA;QACI,aAAa;QACb,eAAe;IACnB;;IAEA;QACI,kBAAkB;QAClB,eAAe;IACnB;AACJ","sourcesContent":[":root {\n    --primary: #e84200;\n    --red: #fa2d00;\n    --grey1: #d7d7d7;\n    --grey2: #d9d9d9;\n    --grey4: #a1a1a1;\n    --grey5: #727272;\n    --darkgrey1: #222222;\n    --darkgrey2: #1c1b1f;\n    --darkgrey3: #000000;\n    --white: #ffffff;\n    --lightgrey2: #f1f1f1;\n}\n\n.product-detail-page {\n    font-family: 'Noto Sans KR', sans-serif;\n    background-color: var(--white, #ffffff);\n}\n\n.detail-breadcrumb {\n    padding: 21px 40px;\n    background: var(--lightgrey2, #f1f1f1);\n    border-bottom: none;\n}\n\n.breadcrumb-content {\n    display: flex;\n    flex-direction: row;\n    gap: 12px;\n    align-items: center;\n    justify-content: flex-start;\n}\n\n.breadcrumb-content a,\n.breadcrumb-content span {\n    color: var(--grey5, #727272);\n    text-align: left;\n    font-family: \"Inter-Regular\", sans-serif;\n    font-size: 16px;\n    font-weight: 400;\n    text-decoration: none;\n}\n\n.breadcrumb-content .current {\n    color: var(--darkgrey3, #000000);\n    font-family: \"Inter-Bold\", sans-serif;\n    font-weight: 700;\n}\n\n.detail-main-content {\n    max-width: 1320px;\n    margin: 0 auto;\n    padding: 40px 0;\n}\n\n.detail-title-section {\n    padding: 0 50px;\n    padding-bottom: 38px;\n    border-bottom: 1px solid var(--darkgrey1, #222222);\n    margin-bottom: 0;\n}\n\n.detail-title-section h1 {\n    color: var(--darkgrey3, #000000);\n    text-align: left;\n    font-family: \"Inter-SemiBold\", sans-serif;\n    font-size: 28px;\n    font-weight: 600;\n    margin: 0;\n    flex: 1;\n    height: 41px;\n}\n\n.detail-content-section {\n    display: flex;\n    flex-direction: row;\n    align-items: flex-start;\n    justify-content: space-between;\n    width: 1320px;\n    max-width: 100%;\n    margin: 0 auto;\n    margin-top: 0;\n    flex-wrap: wrap;\n}\n\n.product-gallery {\n    display: flex;\n    flex-direction: row;\n    gap: 14px;\n    align-items: flex-start;\n    padding: 100px 0 100px 70px;\n    flex-shrink: 0;\n}\n\n.gallery-thumbnails {\n    display: flex;\n    flex-direction: column;\n    gap: 8px;\n    align-items: flex-start;\n    flex-shrink: 0;\n    width: 176px;\n}\n\n.thumbnail-wrapper {\n    border-radius: 3px;\n    border: 1px solid var(--grey4, #a1a1a1);\n    width: 176px;\n    height: 176px;\n    position: relative;\n    overflow: hidden;\n}\n\n.thumbnail {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    cursor: pointer;\n}\n\n.main-image-container {\n    flex-shrink: 0;\n    width: 480px;\n    height: 480px;\n    position: relative;\n    overflow: visible;\n    border: none;\n    background: transparent;\n    border-radius: 0;\n    min-height: auto;\n}\n\n.main-image {\n    width: 100%;\n    height: auto;\n    object-fit: contain;\n    display: block;\n    max-width: 100%;\n    max-height: 100%;\n}\n\n.product-details {\n    flex-shrink: 0;\n    width: 540px;\n    position: relative;\n}\n\n.detail-options {\n    background: transparent;\n    padding: 0;\n    border-radius: 0;\n    border: none;\n    border-bottom: 1px solid var(--darkgrey1, #222222);\n    padding: 32px 16px;\n}\n\n.option-row {\n    display: flex;\n    flex-direction: row;\n    gap: 8px;\n    align-items: center;\n    justify-content: flex-start;\n    margin-bottom: 4px;\n    flex-wrap: wrap;\n}\n\n.option-row:last-child {\n    margin-bottom: 0;\n}\n\n.option-label {\n    color: var(--darkgrey3, #000000);\n    text-align: left;\n    font-family: \"Inter-Medium\", sans-serif;\n    font-size: 18px;\n    font-weight: 500;\n    width: 175px;\n    flex-shrink: 0;\n}\n\n.option-value {\n    color: var(--grey5, #727272);\n    text-align: left;\n    font-family: \"Inter-Medium\", sans-serif;\n    font-size: 18px;\n    font-weight: 500;\n}\n\n.option-select {\n    padding: 14px 16px;\n    border: 1px solid var(--grey1, #d7d7d7);\n    border-radius: 5px;\n    font-size: 18px;\n    font-family: \"Inter-Medium\", sans-serif;\n    font-weight: 500;\n    background: var(--white, #ffffff);\n    color: var(--darkgrey3, #000000);\n    width: 290px;\n    height: 53px;\n    position: relative;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-shrink: 0;\n    box-sizing: border-box;\n}\n\n.quantity-selector {\n    display: flex;\n    flex-direction: row;\n    gap: 0;\n    align-items: center;\n    justify-content: space-between;\n    flex-shrink: 0;\n    position: relative;\n    border: none;\n    border-radius: 5px;\n    width: 290px;\n    height: 53px;\n    box-sizing: border-box;\n}\n\n.quantity-selector button {\n    width: 53px;\n    height: 53px;\n    border: 1px solid var(--grey2, #d9d9d9);\n    background: var(--white, #ffffff);\n    color: var(--darkgrey3, #000000);\n    cursor: pointer;\n    border-radius: 0;\n    font-size: 20px;\n    font-weight: 500;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 0;\n    flex-shrink: 0;\n    box-sizing: border-box;\n}\n\n.quantity-selector button:first-child {\n    border-top-left-radius: 5px;\n    border-bottom-left-radius: 5px;\n    border-right: none;\n}\n\n.quantity-selector button:last-child {\n    border-top-right-radius: 5px;\n    border-bottom-right-radius: 5px;\n    border-left: none;\n}\n\n.quantity-selector-centered button {\n    color: var(--darkgrey3, #000000);\n    font-weight: 600;\n}\n\n.quantity-icon {\n    width: 33px;\n    height: 33px;\n    object-fit: contain;\n}\n\n.quantity-selector button:hover {\n    background: var(--lightgrey2, #f1f1f1);\n    opacity: 1;\n}\n\n.quantity-selector span {\n    border-top: 1px solid var(--grey2, #d9d9d9);\n    border-bottom: 1px solid var(--grey2, #d9d9d9);\n    border-left: 1px solid var(--grey2, #d9d9d9);\n    border-right: 1px solid var(--grey2, #d9d9d9);\n    padding: 5px 4px;\n    flex: 1;\n    min-width: 74.41px;\n    height: 53px;\n    text-align: center;\n    font-family: \"Inter-Regular\", sans-serif;\n    font-size: 18px;\n    font-weight: 400;\n    color: var(--darkgrey3, #000000);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: var(--white, #ffffff);\n    box-sizing: border-box;\n}\n\n.selected-options {\n    margin: 20px 0;\n    padding: 20px;\n    background: #f8f9fa;\n    border-radius: 8px;\n    border: 1px solid #e0e0e0;\n}\n\n.selected-item {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 12px;\n    background: white;\n    border-radius: 4px;\n    margin-bottom: 10px;\n    border: 1px solid #e0e0e0;\n}\n\n.selected-item:last-child {\n    margin-bottom: 0;\n}\n\n.item-info p {\n    margin: 0;\n    font-size: 14px;\n    color: #555;\n}\n\n.item-info p:first-child {\n    font-weight: 500;\n}\n\n.item-info p:last-child {\n    color: #888;\n    font-size: 14px;\n}\n\n.item-controls {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\n.remove-item {\n    background: var(--primary, #e84200);\n    color: white;\n    border: none;\n    width: 24px;\n    height: 24px;\n    border-radius: 4px;\n    cursor: pointer;\n    font-size: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.remove-item:hover {\n    background: #d73502;\n}\n\n.detail-options-divider {\n    padding: 40px 16px;\n    height: 172px;\n}\n\n.product-actions-container {\n    padding: 0 16px;\n    width: 100%;\n    max-width: 540px;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n}\n\n.add-to-cart-btn {\n    background: var(--primary, #e84200);\n    border-radius: 5px;\n    padding: 15px;\n    display: flex;\n    flex-direction: row;\n    gap: 10px;\n    align-items: center;\n    justify-content: center;\n    width: 430px;\n    height: 53px;\n    border: none;\n    cursor: pointer;\n    color: var(--white, #ffffff);\n    text-align: center;\n    font-family: \"Inter-Bold\", sans-serif;\n    font-size: 18px;\n    font-weight: 700;\n    transition: background-color 0.2s ease;\n    margin: 0 auto;\n}\n\n.add-to-cart-btn:hover:not(:disabled) {\n    background: #d73502;\n}\n\n.add-to-cart-btn:disabled {\n    background: var(--grey4, #a1a1a1);\n    cursor: not-allowed;\n}\n\n.add-options-btn {\n    background: var(--primary, #e84200);\n    color: var(--white, #ffffff);\n    border: none;\n    padding: 12px 24px;\n    border-radius: 6px;\n    cursor: pointer;\n    font-size: 14px;\n    font-weight: 500;\n    transition: background-color 0.2s ease;\n    margin-left: 0;\n}\n\n.add-options-btn:hover:not(:disabled):not(.disabled) {\n    background: #d73502;\n}\n\n.add-options-btn:disabled,\n.add-options-btn.disabled {\n    background: var(--grey4, #a1a1a1);\n    cursor: pointer;\n}\n\n.info-box {\n    background: transparent;\n    border: none;\n    border-radius: 0;\n    padding: 10px 0;\n    margin: 20px 0;\n    width: 100%;\n    max-width: 430px;\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    text-align: left;\n}\n\n.info-box p {\n    margin: 0;\n    color: var(--darkgrey3, #000000);\n    font-family: \"Inter-Regular\", sans-serif;\n    font-size: 18px;\n    line-height: 30px;\n    font-weight: 400;\n    text-align: left;\n}\n\n.info-box ul {\n    margin: 0 auto;\n    padding-left: 1em;\n    list-style-type: disc;\n    color: var(--darkgrey3, #000000);\n    font-family: \"Inter-Regular\", sans-serif;\n    font-size: 18px;\n    line-height: 30px;\n    font-weight: 400;\n    width: fit-content;\n}\n\n.info-box span {\n    color: var(--darkgrey3, #000000);\n    font-family: \"Inter-Regular\", sans-serif;\n    font-size: 18px;\n    line-height: 30px;\n    font-weight: 400;\n    text-align: center;\n    display: block;\n    width: 100%;\n}\n\n.document-buttons {\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n    width: 430px;\n    margin-top: 49px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n.doc-btn {\n    align-self: stretch;\n    flex-shrink: 0;\n    height: 53px;\n    position: relative;\n    border-radius: 5px;\n    cursor: pointer;\n    font-size: 18px;\n    transition: all 0.2s ease;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 0 42px;\n}\n\n.pdf-btn {\n    background: var(--white, #ffffff);\n    border: 1px solid var(--darkgrey3, #000000);\n    color: var(--darkgrey3, #000000);\n}\n\n.pdf-btn:hover {\n    border-color: var(--primary, #e84200);\n    color: var(--primary, #e84200);\n}\n\n.cad-btn {\n    background: var(--darkgrey3, #000000);\n    border: 1px solid var(--darkgrey3, #000000);\n    color: var(--white, #ffffff);\n}\n\n.cad-btn:hover {\n    background: var(--primary, #e84200);\n    border-color: var(--primary, #e84200);\n}\n\n.doc-btn span {\n    font-family: \"Inter-Bold\", sans-serif;\n    font-size: 18px;\n    font-weight: 700;\n}\n\n.doc-btn span:first-child {\n    text-align: left;\n}\n\n.doc-btn span:last-child {\n    text-align: right;\n}\n\n.product-detail-image-section {\n    width: 100%;\n    margin: 40px 0;\n    text-align: center;\n}\n\n.detail-main-image {\n    width: 100%;\n    max-width: 1240px;\n    height: auto;\n    object-fit: contain;\n}\n\n.product-extra-details {\n    border-radius: 15px;\n    border: 1px solid var(--grey2, #d9d9d9);\n    padding: 180px 100px 90px 100px;\n    display: flex;\n    flex-direction: column;\n    gap: 240px;\n    align-items: flex-start;\n    justify-content: flex-start;\n    width: 1240px;\n    max-width: 100%;\n    margin: 40px auto;\n    background: var(--white, #ffffff);\n}\n\n.detail-image-full {\n    margin-bottom: 60px;\n    text-align: center;\n}\n\n.detail-image-full img {\n    max-width: 100%;\n    height: auto;\n}\n\n.purchase-info-section {\n    display: flex;\n    flex-direction: column;\n    gap: 40px;\n    align-items: flex-start;\n    justify-content: flex-start;\n    align-self: stretch;\n    flex-shrink: 0;\n    position: relative;\n}\n\n.purchase-info-section h3 {\n    color: var(--darkgrey3, #000000);\n    text-align: left;\n    font-family: \"Inter-SemiBold\", sans-serif;\n    font-size: 18px;\n    font-weight: 600;\n    position: relative;\n    align-self: stretch;\n    margin: 0;\n}\n\n.purchase-steps {\n    padding: 0 30px;\n    display: flex;\n    flex-direction: column;\n    gap: 19px;\n    align-items: flex-start;\n    justify-content: flex-start;\n    align-self: stretch;\n    flex-shrink: 0;\n    position: relative;\n}\n\n.purchase-desc {\n    color: var(--grey5, #727272);\n    text-align: left;\n    font-family: \"Inter-Medium\", sans-serif;\n    font-size: 16px;\n    line-height: 28px;\n    font-weight: 500;\n    position: relative;\n    align-self: stretch;\n    margin: 0;\n}\n\n.contact-methods {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    align-items: flex-start;\n    justify-content: flex-start;\n    flex-shrink: 0;\n    width: 281px;\n    position: relative;\n}\n\n.contact-item {\n    display: flex;\n    flex-direction: row;\n    gap: 11px;\n    align-items: center;\n    justify-content: flex-start;\n    align-self: stretch;\n    flex-shrink: 0;\n    position: relative;\n}\n\n.contact-icon {\n    border-radius: 0px;\n    flex-shrink: 0;\n    width: 19px;\n    height: 19px;\n    position: relative;\n    overflow: visible;\n}\n\n.contact-info {\n    display: flex;\n    flex-direction: row;\n    gap: 4px;\n    align-items: center;\n    justify-content: flex-start;\n    flex-shrink: 0;\n    position: relative;\n}\n\n.contact-label {\n    color: var(--darkgrey3, #000000);\n    text-align: left;\n    font-family: \"Inter-SemiBold\", sans-serif;\n    font-size: 18px;\n    line-height: 28px;\n    font-weight: 600;\n    position: relative;\n}\n\n.contact-value {\n    color: var(--primary, #e84200);\n    text-align: left;\n    font-family: \"Inter-SemiBold\", sans-serif;\n    font-size: 18px;\n    line-height: 28px;\n    font-weight: 600;\n    position: relative;\n    text-decoration: none;\n}\n\n.purchase-steps-indicator {\n    padding: 10px 80px;\n    display: flex;\n    flex-direction: column;\n    gap: 10px;\n    align-items: flex-start;\n    justify-content: flex-start;\n    flex-shrink: 0;\n    position: relative;\n}\n\n.step-indicator {\n    flex-shrink: 0;\n    width: 466px;\n    height: 25px;\n    position: relative;\n}\n\n.step-indicator-bg {\n    background: var(--primary, #e84200);\n    width: 94.64%;\n    height: 12%;\n    position: absolute;\n    right: 2.58%;\n    left: 2.79%;\n    bottom: 44%;\n    top: 44%;\n    z-index: 1;\n}\n\n.step-indicator-fill {\n    background: var(--primary, #e84200);\n    width: 47.42%;\n    height: 12%;\n    position: absolute;\n    right: 49.79%;\n    left: 2.79%;\n    bottom: 44%;\n    top: 44%;\n    z-index: 2;\n}\n\n.step-item {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    align-items: center;\n    justify-content: flex-start;\n    width: 5.36%;\n    height: 100%;\n    position: absolute;\n    z-index: 3;\n}\n\n.step-item:first-child {\n    right: 94.64%;\n    left: 0%;\n    bottom: 0%;\n    top: 0%;\n}\n\n.step-item:nth-child(3) {\n    right: 47.21%;\n    left: 47.42%;\n    bottom: 0%;\n    top: 0%;\n}\n\n.step-item:last-child {\n    right: 0%;\n    left: 94.64%;\n    bottom: 0%;\n    top: 0%;\n}\n\n.step-circle {\n    background: var(--primary, #e84200);\n    border-radius: 50%;\n    flex-shrink: 0;\n    width: 25px;\n    height: 25px;\n    position: relative;\n}\n\n.step-item span {\n    color: var(--darkgrey3, #000000);\n    text-align: center;\n    font-family: \"Inter-SemiBold\", sans-serif;\n    font-size: 18px;\n    font-weight: 600;\n    position: absolute;\n    left: 50%;\n    transform: translateX(-50%);\n    top: 45px;\n    white-space: nowrap;\n}\n\n.purchase-info-section h3:last-of-type {\n    margin-top: 50px;\n}\n\n.specs-content {\n    padding: 0 30px;\n    display: flex;\n    flex-direction: row;\n    gap: 8px;\n    align-items: center;\n    justify-content: flex-start;\n    align-self: stretch;\n    flex-shrink: 0;\n    position: relative;\n}\n\n.specs-labels {\n    color: var(--grey5, #727272);\n    text-align: left;\n    font-family: \"Inter-Medium\", sans-serif;\n    font-size: 16px;\n    line-height: 30px;\n    font-weight: 500;\n    position: relative;\n    width: 143px;\n}\n\n.specs-values {\n    color: var(--grey5, #727272);\n    text-align: left;\n    font-family: \"Inter-Medium\", sans-serif;\n    font-size: 16px;\n    line-height: 30px;\n    font-weight: 500;\n    position: relative;\n    flex: 1;\n}\n\n.shipping-exchange-section {\n    display: flex;\n    flex-direction: column;\n    gap: 60px;\n    align-items: flex-start;\n    justify-content: flex-start;\n    width: 1240px;\n    max-width: 100%;\n    padding: 0 100px;\n    margin: 0 auto;\n}\n\n.shipping-info-section,\n.exchange-info-section {\n    display: flex;\n    flex-direction: column;\n    gap: 20px;\n    align-items: flex-start;\n    justify-content: flex-start;\n    align-self: stretch;\n    flex-shrink: 0;\n    position: relative;\n}\n\n.shipping-info-section h3,\n.exchange-info-section h3 {\n    color: var(--darkgrey3, #000000);\n    text-align: left;\n    font-family: \"Inter-SemiBold\", sans-serif;\n    font-size: 18px;\n    font-weight: 600;\n    position: relative;\n    align-self: stretch;\n    margin: 0;\n}\n\n.info-content {\n    padding: 0 30px;\n    color: var(--grey5, #727272);\n    text-align: left;\n    font-family: \"Inter-Medium\", sans-serif;\n    font-size: 16px;\n    font-weight: 500;\n    position: relative;\n    flex: 1;\n    line-height: 1.8;\n}\n\n/* Tablet and smaller devices */\n@media (max-width: 1024px) {\n    .detail-main-content {\n        padding: 20px;\n    }\n\n    .detail-content-section {\n        flex-direction: column;\n    }\n\n    .product-gallery, .product-details {\n        width: 100%;\n    }\n}\n\n/* Mobile devices */\n@media (max-width: 768px) {\n    .detail-breadcrumb {\n        padding: 12px 15px;\n    }\n    \n    .breadcrumb-content {\n        font-size: 11px;\n        flex-wrap: wrap;\n        gap: 6px;\n    }\n    \n    .breadcrumb-content a,\n    .breadcrumb-content span {\n        font-size: 11px;\n    }\n    \n    .detail-main-content {\n        padding: 15px;\n        width: 100%;\n        max-width: 100%;\n    }\n\n    .detail-title-section {\n        padding: 0 15px;\n        padding-bottom: 15px;\n        margin-bottom: 0;\n    }\n\n    .detail-title-section h1 {\n        font-size: 18px;\n        height: auto;\n        line-height: 1.4;\n    }\n\n    .detail-content-section {\n        flex-direction: column;\n        width: 100%;\n        padding: 0;\n        margin-top: 0;\n    }\n\n    .product-gallery {\n        flex-direction: column;\n        padding: 15px 0;\n        width: 100%;\n        gap: 10px;\n    }\n\n    .gallery-thumbnails {\n        flex-direction: row;\n        overflow-x: auto;\n        width: 100%;\n        gap: 8px;\n        padding: 0 15px 10px 15px;\n        -webkit-overflow-scrolling: touch;\n    }\n    \n    .thumbnail-wrapper {\n        flex-shrink: 0;\n        width: 80px;\n        height: 80px;\n    }\n    \n    .thumbnail {\n        width: 80px;\n        height: 80px;\n    }\n\n    .main-image-container {\n        width: 100%;\n        height: auto;\n        order: -1;\n        padding: 0 15px;\n    }\n    \n    .main-image {\n        width: 100%;\n        height: auto;\n        max-height: 400px;\n        object-fit: contain;\n    }\n\n    .product-details {\n        width: 100%;\n        padding: 20px 15px;\n    }\n    \n    .detail-options {\n        padding: 20px 15px;\n    }\n\n    .option-row {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 10px;\n        width: 100%;\n        margin-bottom: 15px;\n    }\n    \n    .option-label {\n        min-width: auto;\n        margin-right: 0;\n        width: 100%;\n        font-size: 16px;\n    }\n    \n    .option-value,\n    .option-select {\n        width: 100%;\n        font-size: 16px;\n    }\n    \n    .quantity-selector {\n        width: 100%;\n        height: 40px;\n        justify-content: space-between;\n    }\n    \n    .quantity-selector button,\n    .quantity-icon {\n        width: 40px;\n        height: 40px;\n    }\n    \n    .quantity-selector span {\n        font-size: 16px;\n        min-width: 60px;\n        height: 40px;\n    }\n    \n    .option-select {\n        width: 100%;\n        height: 40px;\n    }\n    \n    .selected-options {\n        margin: 15px 0;\n        padding: 15px;\n    }\n    \n    .selected-item {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 10px;\n        padding: 12px;\n    }\n    \n    .item-controls {\n        width: 100%;\n        justify-content: flex-end;\n    }\n    \n    .add-to-cart-btn {\n        width: 100%;\n        max-width: 100%;\n        height: 48px;\n        font-size: 16px;\n        padding: 12px;\n    }\n    \n    .add-options-btn {\n        width: 100%;\n        padding: 12px;\n        font-size: 14px;\n    }\n    \n    .detail-options-divider {\n        padding: 30px 15px;\n        height: auto;\n    }\n    \n    .info-box {\n        padding: 15px;\n        margin: 15px 0;\n    }\n    \n    .info-box p,\n    .info-box ul,\n    .info-box span {\n        font-size: 14px;\n        line-height: 1.6;\n        text-align: left;\n    }\n    \n    .document-buttons {\n        flex-direction: column;\n        width: 100%;\n        margin-top: 30px;\n        gap: 10px;\n    }\n    \n    .doc-btn {\n        width: 100%;\n        height: 48px;\n        padding: 0 20px;\n        font-size: 16px;\n    }\n    \n    .doc-btn span {\n        font-size: 16px;\n    }\n    \n    .product-extra-details {\n        width: 100%;\n        padding: 30px 15px;\n        margin: 20px auto;\n        gap: 40px;\n        border-radius: 8px;\n    }\n    \n    .detail-image-full {\n        margin-bottom: 30px;\n    }\n    \n    .detail-image-full img {\n        width: 100%;\n        height: auto;\n    }\n    \n    .purchase-info-section {\n        padding: 20px 15px;\n        width: 100%;\n    }\n    \n    .purchase-steps {\n        flex-direction: column;\n        gap: 15px;\n        margin: 20px 0;\n        padding: 0;\n    }\n    \n    .purchase-steps-indicator {\n        padding: 10px 0;\n        width: 100%;\n    }\n    \n    .step-indicator {\n        width: 100%;\n        max-width: 100%;\n        height: 20px;\n    }\n    \n    .step-item span {\n        font-size: 12px;\n        top: 30px;\n    }\n    \n    .purchase-desc {\n        font-size: 14px;\n        line-height: 1.6;\n        margin: 15px 0;\n        padding: 0;\n    }\n    \n    .contact-methods {\n        flex-direction: column;\n        gap: 15px;\n        margin: 20px 0;\n        width: 100%;\n        padding: 0;\n    }\n    \n    .contact-item {\n        width: 100%;\n        padding: 10px 0;\n    }\n    \n    .contact-label,\n    .contact-value {\n        font-size: 14px;\n        line-height: 1.6;\n    }\n    \n    .contact-icon {\n        width: 16px;\n        height: 16px;\n    }\n    \n    .specs-content {\n        flex-direction: column;\n        gap: 10px;\n        padding: 0;\n        margin: 15px 0;\n    }\n    \n    .specs-labels,\n    .specs-values {\n        font-size: 14px;\n        line-height: 1.6;\n        width: 100%;\n    }\n    \n    .specs-table {\n        width: 100%;\n        font-size: 12px;\n        margin: 15px 0;\n        display: block;\n        overflow-x: auto;\n    }\n    \n    .specs-table th,\n    .specs-table td {\n        padding: 10px 8px;\n        font-size: 12px;\n        white-space: nowrap;\n    }\n    \n    .shipping-exchange-section {\n        width: 100%;\n        padding: 0 15px;\n        margin: 0 auto;\n        gap: 40px;\n    }\n    \n    .shipping-info-section,\n    .exchange-info-section {\n        padding: 20px 0;\n        width: 100%;\n        gap: 15px;\n    }\n    \n    .shipping-info-section h3,\n    .exchange-info-section h3 {\n        font-size: 18px;\n        margin-bottom: 10px;\n    }\n    \n    .info-content {\n        padding: 0;\n        font-size: 14px;\n        line-height: 1.6;\n    }\n    \n    .shipping-info-section p,\n    .exchange-info-section p {\n        font-size: 14px;\n        line-height: 1.6;\n        margin: 10px 0;\n    }\n    \n    .product-detail-image-section {\n        margin: 20px 0;\n        padding: 0 15px;\n    }\n    \n    .detail-main-image {\n        width: 100%;\n        max-width: 100%;\n    }\n}\n\n/* Full width 이미지 스타일 */\n.detail-image-full-width {\n    width: 100%;\n    margin: 20px 0;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    overflow: hidden;\n    background: #f8f9fa;\n}\n\n.detail-image-full-width img {\n    width: 100%;\n    height: auto;\n    object-fit: contain;\n    display: block;\n}\n\n.detail-image-full-width .image-placeholder {\n    width: 100%;\n    height: 300px;\n    border-radius: 8px;\n    background-color: #f8f9fa;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n@media (max-width: 768px) {\n    .detail-image-full-width {\n        padding: 0 20px;\n        margin: 15px auto;\n    }\n    \n    .detail-image-full-width .image-placeholder {\n        height: 200px;\n    }\n} \n\n/* 반응형 디자인 */\n@media (max-width: 768px) {\n    .detail-content-section {\n        flex-direction: column;\n        gap: 20px;\n    }\n    \n    .product-gallery {\n        margin-right: 0;\n        max-width: 100%;\n    }\n    \n    .option-row {\n        flex-direction: column;\n        align-items: flex-start;\n        gap: 8px;\n    }\n    \n    .option-label {\n        min-width: auto;\n        margin-right: 0;\n    }\n    \n    .document-buttons {\n        flex-direction: column;\n    }\n    \n    .detail-breadcrumb {\n        padding: 15px 20px;\n    }\n    \n    .breadcrumb-content {\n        flex-wrap: wrap;\n        gap: 8px;\n    }\n    \n    .detail-title-section {\n        padding: 20px;\n    }\n    \n    .detail-title-section h1 {\n        font-size: 24px;\n    }\n    \n    .detail-main-content {\n        padding: 0 20px 40px;\n    }\n}\n\n@media (max-width: 480px) {\n    .detail-breadcrumb {\n        padding: 10px 15px;\n    }\n    \n    .breadcrumb-content {\n        font-size: 14px;\n    }\n    \n    .detail-title-section {\n        padding: 15px;\n    }\n    \n    .detail-title-section h1 {\n        font-size: 20px;\n    }\n    \n    .detail-main-content {\n        padding: 0 15px 30px;\n    }\n    \n    .option-row {\n        margin-bottom: 15px;\n    }\n    \n    .option-label {\n        font-size: 14px;\n    }\n    \n    .option-select,\n    .quantity-selector {\n        font-size: 14px;\n    }\n    \n    .add-options-btn {\n        padding: 10px 20px;\n        font-size: 14px;\n    }\n    \n    .info-box {\n        padding: 12px;\n        font-size: 13px;\n    }\n    \n    .doc-btn {\n        padding: 10px 14px;\n        font-size: 13px;\n    }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
